import classNames from "classnames";
import { BG_COLORS } from "constant/app";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

class SmallBox extends React.Component {
  static get displayName() {
    return "SmallBox";
  }

  static get propTypes() {
    return {
      boxTitle: PropTypes.string.isRequired,
      className: PropTypes.string,
      color: PropTypes.oneOf(BG_COLORS).isRequired,
      desc: PropTypes.node,
      icon: PropTypes.string.isRequired,
      linkAnchor: PropTypes.string,
      linkHref: PropTypes.string,
    };
  }

  static get defaultProps() {
    return {
      className: "",
    };
  }

  render() {
    const {
      boxTitle,
      className,
      color,
      desc,
      icon,
      linkAnchor,
      linkHref,
      ...attrs
    } = this.props;

    return (
      <div
        className={classNames("small-box", `bg-${color}`, className)}
        {...attrs}
      >
        <div className="inner">
          <h3>{boxTitle}</h3>
          {desc}
        </div>
        <div className="icon">
          <i className={classNames("fa", `fa-${icon}`)} />
        </div>
        {linkHref && (
          <Link to={linkHref} className="small-box-footer">
            {linkAnchor} <i className="fa fa-arrow-circle-right" />
          </Link>
        )}
      </div>
    );
  }
}

export default SmallBox;
export { SmallBox };
